// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ForeignDataObjectColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Foreign Data Object Column component
 */

import React from 'react';
import AppGlobal from 'Izenda.AppGlobal';
import RelationshipColumn from './Izenda.RelationshipColumn';
import Validator from 'share/components/hoc/Izenda.Validator';
import Select from 'share/components/controls/multiSelectBox/Izenda.Select';
const ValidateSelect = Validator()(Select);

export default function render(relationshipItem: any): any {
  const relationshipVM = this.props.store;
  const updateValueFunc = updateValue.bind(this, relationshipItem);
  const options = {
    options: relationshipItem.getListForeignQuerySource(),
    valueKey: 'key',
    labelKey: AppGlobal.advancedSettings.other.showSchemaNameValue ? 'valueDisplay' : 'value',
    simpleValue: true
  };

  return (
    <RelationshipColumn
      relationshipItem={relationshipItem}
      store={relationshipVM}
      fieldCheck={'foreignQuerySourceId'}
      selectedFunction={relationshipItem.getForeignQuerySource()}
      setFunction={updateValueFunc}
      rowIndex={relationshipItem.position}
      component={ValidateSelect}
      componentOptions={options}
    />
  );

  function updateValue(relationshipItem: any, value: any, label: string, isNew: boolean): void {
    const currentForeignQuerySourceId = relationshipItem.foreignQuerySourceId;
    const result = relationshipVM.resetNewValueToDefault(value, label, isNew);
    relationshipItem.setForeignQuerySource(result.value, result.label, isNew);
    this.checkExistEntities(relationshipItem, currentForeignQuerySourceId, relationshipItem.setForeignQuerySource);
  }
}


// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/Relationship/Izenda.ForeignDataObjectColumn.js